import { render, staticRenderFns } from "./SurveysViewOnMap.vue?vue&type=template&id=220f268b&scoped=true&"
import script from "./SurveysViewOnMap.vue?vue&type=script&lang=js&"
export * from "./SurveysViewOnMap.vue?vue&type=script&lang=js&"
import style0 from "./SurveysViewOnMap.vue?vue&type=style&index=0&id=220f268b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f268b",
  null
  
)

export default component.exports